declare global {
  interface Window {
    lightCli: any;
  }
}
export const postToApp = (code: string, data: any = '') => {
  try {
    window.lightCli.postMessage(JSON.stringify({ 'code': code, 'data': data }));
  } catch (e) {

  }
};

export const channelMethods = {
  goBack: 'getBack',
  goPrivacy: 'goPrivacy',
  getResult: 'getResult',
  copy: 'getCopy',
  darkMode: 'setDarkMode',
  setTitle: 'setTitle',
  login: 'getLogin',
  auth: 'getAuth',
  email: 'getEmail',
  tel: 'getTel',
  scrollToEnd: 'scrollToEnd'
};
